import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import { rememberEnhancer } from 'redux-remember';
import { REDUX_REMEMBER_PREFIX } from '../const/localStorageKeys';
// import apiClient from '../API/apiClient'
// import { applyLogoutMiddleWare } from '../API/middlewares/ApiLogoutMidleware'
import AppReducers from './index';
// applyLogoutMiddleWare(apiClient)
export const store = configureStore({
    reducer: AppReducers,
    middleware: getDefaultMiddleware => {
        const middlewares = getDefaultMiddleware();
        if (process.env.NODE_ENV !== 'production') {
            if (process.env.NODE_ENV !== 'test') {
                middlewares.push(logger);
            }
        }
        return middlewares;
    },
    enhancers: getDefaultEnhancers => getDefaultEnhancers().concat(rememberEnhancer(window.localStorage, ['user', 'account'], { prefix: REDUX_REMEMBER_PREFIX })),
});
window.store = store;
